import dayjs from 'Utilities/dayjs';

import type { GetVehicle } from '../helpers/vehicle.schema';
import { ServiceRecordValues } from '../schemas/serviceHistory.schema';

export const serviceHistorySectionTransformer = (vehicle: GetVehicle) => ({
	createdAt: vehicle.createdAt,
	distanceInterval: vehicle.serviceHistoryRecords?.intervals.distance ?? null,
	hasPaasProfile: vehicle.hasPaasProfile,
	independentServiceStampsCount: vehicle.independentServiceStampsCount,
	isSold: !!vehicle.soldDate,
	make: vehicle.spec.make,
	mileage: vehicle.mileage,
	model: vehicle.spec.model,
	officialServiceStampsCount: vehicle.officialServiceStampsCount,
	serviceHistoryRecords: vehicle.serviceHistoryRecords,
	serviceRecord: vehicle.serviceRecord ?? ServiceRecordValues.NOT_PROVIDED,
	soldDate: vehicle.soldDate ?? null,
	timeInterval: vehicle.serviceHistoryRecords?.intervals.time ?? null,
	vehicleAge: dayjs(vehicle.soldDate || undefined).diff(dayjs(vehicle.spec.firstRegistered), 'year'),
	vrm: vehicle.vrm,
});
